import React, { Component, PropTypes } from 'react';
import './style.scss'
import {Link} from 'react-router'
import moment from 'moment'

import { browserHistory } from 'react-router'

export class Job extends Component {

  constructor(props) {
    super(props)
    this.go = this.go.bind(this)
  }

  go (link) {
    if (this.props.go) browserHistory.push(link)
  }


  render() {
    let classNames = this.props.class ? this.props.class : "col-sm-6 col-md-4 col-lg-3";
    return (
      <Link className={`job-pod ${this.props.job.selected_status.class} ${classNames}`} onClick={() => this.go(`/job/${this.props.id}/tabs-view`)}>
        <div className='body'>
          <h3 className='m-0'>
            {this.props.job.label} <span className="badge hidden">NEW</span>
          </h3>
          { this.props.job.start &&<label className='m-0'>{moment(this.props.job.start).format("Do MMMM YYYY")}</label>}
          <br/>
          <h3 className='m-t-md'>£{this.props.job.total && (Number(this.props.job.total.sale)-Number(this.props.job.total.cost)).toFixed(2)}</h3><br/>
        </div>
      </Link>
    )
  }
}


export default Job



// WEBPACK FOOTER //
// ./src/views/components/Job/index.js